import { Roles, User } from '../../../models/Auth'

export const isTriageOfficer = (user: User) => {
  return user.Roles.includes(Roles.TriageOfficer)
}

export default isTriageOfficer
